// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
// ─────────────────────────────────────────────────────────────────────────────
// CRITICAL PAGE STYLES
// Above-the-fold and high-priority styles for the home page's landing section.
// Put the first section of the home page in here, so it loads immediately.
// The rest of the home page styles in local.css will be deferred and
// ─────────────────────────────────────────────────────────────────────────────
 */

/* ******************* */
/*        HERO         */
/* ******************* */
#hero {
  /* Centers button */
  text-align: center;
  padding: var(--section-padding);

  .container {
    max-width: calc(var(--section-max-width) / 16 * 1rem);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 160px auto;
    grid-template-areas:
      "left right"
      "text text";
    row-gap: 3rem;
  }

  .left-faces,
  .right-faces {
    width: auto;
    height: 100%;
    position: relative;

    & > img {
      height: 100%;
      width: auto;
      position: absolute;
      bottom: 0;
    }
  }

  .left-faces {
    grid-area: left;
    & > img {
      right: 8.5px;
    }
  }

  .right-faces {
    grid-area: right;
    & > img {
      left: 8.5px;
    }
  }

  .content {
    grid-area: text;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }
}

/* TABLET */
@media only screen and (min-width: 42rem) {
  #hero {
    .container {
      row-gap: 4.5rem;
      grid-template-rows: 303px auto;
    }

    .content {
      margin: 0 auto;
      max-width: 448.3px;
    }

    .button-container {
      flex-direction: row;
    }

    .left-faces {
      & > img {
        right: 16px;
      }
    }

    .right-faces {
      & > img {
        left: 16px;
      }
    }
  }
}

/* DESKTOP */
@media only screen and (min-width: 64rem) {
  #hero {
    padding: 4rem 5rem;

    .container {
      height: 360px;
      margin: 0 auto;
      grid-template-columns: 1fr auto 1fr;
      grid-template-areas: "left text right";
      gap: 2rem;
    }

    .left-faces {
      & > img {
        right: 32%;
      }
    }

    .right-faces {
      & > img {
        left: 32%;
      }
    }

    .content {
      gap: 2rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/critical.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;;EAE/B;IACE,qDAAqD;IACrD,aAAa;IACb,qCAAqC;IACrC,8BAA8B;IAC9B;;iBAEa;IACb,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;;IAElB;MACE,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,SAAS;IACX;EACF;;EAEA;IACE,eAAe;IACf;MACE,YAAY;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB;MACE,WAAW;IACb;EACF;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA,WAAW;AACX;EACE;IACE;MACE,eAAe;MACf,8BAA8B;IAChC;;IAEA;MACE,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE;QACE,WAAW;MACb;IACF;;IAEA;MACE;QACE,UAAU;MACZ;IACF;EACF;AACF;;AAEA,YAAY;AACZ;EACE;IACE,kBAAkB;;IAElB;MACE,aAAa;MACb,cAAc;MACd,mCAAmC;MACnC,sCAAsC;MACtC,SAAS;IACX;;IAEA;MACE;QACE,UAAU;MACZ;IACF;;IAEA;MACE;QACE,SAAS;MACX;IACF;;IAEA;MACE,SAAS;IACX;EACF;AACF","sourcesContent":["/* \n// ─────────────────────────────────────────────────────────────────────────────\n// CRITICAL PAGE STYLES\n// Above-the-fold and high-priority styles for the home page's landing section.\n// Put the first section of the home page in here, so it loads immediately.\n// The rest of the home page styles in local.css will be deferred and\n// ─────────────────────────────────────────────────────────────────────────────\n */\n\n/* ******************* */\n/*        HERO         */\n/* ******************* */\n#hero {\n  /* Centers button */\n  text-align: center;\n  padding: var(--section-padding);\n\n  .container {\n    max-width: calc(var(--section-max-width) / 16 * 1rem);\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: 160px auto;\n    grid-template-areas:\n      \"left right\"\n      \"text text\";\n    row-gap: 3rem;\n  }\n\n  .left-faces,\n  .right-faces {\n    width: auto;\n    height: 100%;\n    position: relative;\n\n    & > img {\n      height: 100%;\n      width: auto;\n      position: absolute;\n      bottom: 0;\n    }\n  }\n\n  .left-faces {\n    grid-area: left;\n    & > img {\n      right: 8.5px;\n    }\n  }\n\n  .right-faces {\n    grid-area: right;\n    & > img {\n      left: 8.5px;\n    }\n  }\n\n  .content {\n    grid-area: text;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1.5rem;\n  }\n\n  .button-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 42rem) {\n  #hero {\n    .container {\n      row-gap: 4.5rem;\n      grid-template-rows: 303px auto;\n    }\n\n    .content {\n      margin: 0 auto;\n      max-width: 448.3px;\n    }\n\n    .button-container {\n      flex-direction: row;\n    }\n\n    .left-faces {\n      & > img {\n        right: 16px;\n      }\n    }\n\n    .right-faces {\n      & > img {\n        left: 16px;\n      }\n    }\n  }\n}\n\n/* DESKTOP */\n@media only screen and (min-width: 64rem) {\n  #hero {\n    padding: 4rem 5rem;\n\n    .container {\n      height: 360px;\n      margin: 0 auto;\n      grid-template-columns: 1fr auto 1fr;\n      grid-template-areas: \"left text right\";\n      gap: 2rem;\n    }\n\n    .left-faces {\n      & > img {\n        right: 32%;\n      }\n    }\n\n    .right-faces {\n      & > img {\n        left: 32%;\n      }\n    }\n\n    .content {\n      gap: 2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
